import { render, staticRenderFns } from "./CardExperience.vue?vue&type=template&id=65b4dce7&scoped=true&"
import script from "./CardExperience.vue?vue&type=script&lang=js&"
export * from "./CardExperience.vue?vue&type=script&lang=js&"
import style0 from "./CardExperience.vue?vue&type=style&index=0&id=65b4dce7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4dce7",
  null
  
)

export default component.exports